import { KeycloakService } from 'src/user/KeycloakService'

export function handleLogout(): void {
  KeycloakService.getKeycloakInstance().logout()
}
